module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_78-0516e726076ae0918686a394a1a33e47.png";